import React, { Component, Suspense } from 'react';
import ReactLoading from 'react-loading';
import './App.css';
import { HashRouter as Router, withRouter } from 'react-router-dom';
import './i18n';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import { Routes } from './routes/routes';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Suspense fallback={<ReactLoading type={"spokes"} color={"#3FD2C7"} height={60} width={60} className="loader"/>}>
          <ToastContainer className="toster" />
          <AuthProvider>
            <Router>
              <Routes />
            </Router>
          </AuthProvider>
        </Suspense>
      </div>
    );
  }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/App.js